import styled, { css } from 'styled-components'

// BOTAO QUE ENVOLVE O CARD. NAO RESETA background/padding DE PROPOSITO:
// AS 4 TELAS QUE USAM ESSE CARD DEPENDEM DO ESTILO PADRAO DO NAVEGADOR (NAO HÁ RESET NO APP).
// O `&&` DOBRA A ESPECIFICIDADE PARA VENCER O `button { cursor: pointer }` DE Servicos/styles.js
export const CardButton = styled.button`
  && {
    cursor: ${({ $indisponivel }) => ($indisponivel ? 'not-allowed' : 'pointer')};
  }
`

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  height: 100px;
  border-radius: 5px;
  background-color: #FFF;
  box-shadow: 0px 5px 14px rgba(0,0,0,0.1);
  padding: ${({ $hasTime }) => ($hasTime ? '18px 10px 0' : '0 10px')};
  margin-bottom: 10px;
  position: relative;

  ${({ $indisponivel }) => $indisponivel && css`
    background-color: #E4E4E4;
    box-shadow: none;

    h1, h2 {
      color: #959595;
    }

    img {
      filter: grayscale(1);
      opacity: 0.45;
    }
  `}
`

export const Time = styled.span`
  position: absolute;
  top: 5px;
  left: 0;
  width: 100%;
  text-align: center;
  font-size: 10px;
  color: ${({ $indisponivel }) => ($indisponivel ? '#444444' : '#959595')};
  font-weight: ${({ $indisponivel }) => ($indisponivel ? 'bold' : 'normal')};
`

export const LeftSide = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-evenly;

  h2{
    font-size: 12px;
    font-weight: bold;
    color: #444444;
  }
`

export const Topo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  h1{
    font-size: 12px;
    font-weight: bold;
    color: #444444;
  }

  div {
    padding-top: 9px;
    font-size: 10px;
    color: #959595;
  }

`

export const RightSide = styled.div`
  display: flex;
  align-self: center;
  width: 80px;
  height: 80px;
  /* background-image: url(${({ bg }) =>  bg});
  background-position: 100% 100%;
  background-size: cover; */
  img{
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

`

export const CarrinhoButton = styled.button`
  border: none;
  outline: none;
  cursor: pointer;
`
